import axios from 'axios';
import { Auth } from 'aws-amplify';

export const handleError = error => {

};

const connect = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    //'Access-Control-Allow-Origin': '*',
  },
});

connect.interceptors.request.use(
  async (config) => {
    console.log("HOLA")
    await getToken(config);
    return config;

  },
  (error) => {
    console.error("error", error);
    return Promise.reject(error);
  },
);

connect.interceptors.response.use(
  (res) => {
    return res;
  },
  async (error) => {
    
    const originalConfig = error.config;
    if (error.response) {
      /*
      if (error.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        // Do something, call refreshToken() request for example;
        // return a request
        return axios_instance(config);
      }
      */
     
      if (error.response.status === 401) {
        // Do something
        
        //alert("401")
        return Promise.reject(error.response.data);
      }

      if (error.response.status !== 401) {
        // Do something 
        //alert("!401")
        return Promise.reject(error.response.data);
      }
    }

    return Promise.reject(error);

  }

);

const getToken = async (config) => {
  //console.log("🐔", JSON.parse(localStorage.getItem('client_data')).prefijo);
  const expirationDate = isJwtExpiringIn10Minutes();

  if(expirationDate){
    //refresh
    if(localStorage.getItem('refresh_token')){
      const refreshToken_ = await refreshToken();
    }
    
  }
  //console.log("🦄", localStorage.getItem('access_token'))
  config.headers.Authorization = localStorage.getItem('access_token');

  /*
  await Auth.currentSession().then(res=>{
    const idToken = res.getIdToken();
    config.headers.Authorization = idToken.jwtToken;
  })
  */
}

const refreshToken = async () => {
    axios.post(`${process.env.REACT_APP_BASE_URL}/onepanel/refresh_token`, 
      { refreshToken: localStorage.getItem('refresh_token') }, 
      { headers: {
        'name_group': JSON.parse(localStorage.getItem('client_data')).prefijo
      } }
    )
    .then(response => {
      
      if('RefreshToken' in response.data){
        localStorage.setItem('refresh_token', response.data.RefreshToken);
      }

      console.log("🐹 REFRESH TOKEN - - - - - - - - - - - -");
      console.log("ACTUAL", localStorage.getItem('access_token'));
      console.log("- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -");
      console.log("NUEVO", response.data.idToken);
      console.log("🐹 REFRESH TOKEN - - - - - - - - - - - -");

      localStorage.setItem('access_token', response.data.idToken);
      //get_terms_and_conditions(response.data)
    })
    .catch(error => {
      //console.error(error);
    });
  };

const isJwtExpiringIn10Minutes = () => {
  let token = localStorage.getItem('access_token');
  if (!token) return false;
  const payload = token.split('.')[1];
  if (!payload) return false;
  const decoded = JSON.parse(atob(payload));
  if (!decoded.exp) return false;
  const expiration = decoded.exp * 1000;
  const now = Date.now();
  // 10 minutos en milisegundos = 600000
  console.log("🦄", (expiration - now) + " <= " + 600000, (expiration - now) <= 600000)
  return (expiration - now) <= 600000;
}

export default connect;
